import { render, staticRenderFns } from "./CurrencyReference.vue?vue&type=template&id=6b7581eb"
import script from "./CurrencyReference.vue?vue&type=script&lang=js"
export * from "./CurrencyReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports